import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: relative;
    &:focus {
        outline: 3px solid #ffdd00;
        outline-offset: 0;
    }
`;

export const DropdownToggler = styled.button`
    position: relative;
    width: 100%;
    padding: 7px 15px;
    margin: 0 auto;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    border: 1px solid rgba(0, 0, 0, .15);
    background-color: #06c;
    outline: none;
    box-shadow: 0 1px 1px rgba(50, 50, 50, .1);
    display: flex;
    align-items: center;
    justify-content: center

    svg {
        position: relative;
        color: #fff;
    }
    
    span {
        margin-left: 10px;
        position: relative;
        top: 2px;
        font-weight: 500;
    }

    &.disabled {
        cursor: default;
        background-color: #e1e2eb;
    }
    &.disabled:after {
        border: none;
    }
    
    &:focus {
        outline: 3px solid #ffdd00;
        outline-offset: 0;
    }
`;

export const DropdownMenu = styled.div`
        position: absolute;
        top: 100%;
        right: 0;
        left: -180.8438px;
        z-index: 1001;
        display: block;
        width: inherit;
        max-height: 182px;
        padding: 0;
        font-weight: normal;
        list-style: none;
        visibility: hidden;
        background-color: #fff;
        border: 1px solid #eee;
        box-shadow: 2px 3px 2px 1px rgba(0, 0, 0, .05);

        &.active {
            visibility: visible;
            overflow-x: hidden;
            overflow-y: auto;
        }
       
        @media (min-width: 767px) {
            max-height: 270px;
        }
        
`;

export const DropdownMenuList = styled.div`
  
`;

export const DropdownMenuItem = styled.li`
        position: relative;
        display: block;
        padding: 13px 20px;
        font-size: 13px;
        color: #555;
        text-decoration: none;
        white-space: nowrap;
        cursor: pointer;
        border-bottom: 2px solid #ccc;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 1);

        &:last-of-type a {
            border: none;
            border-radius: 0 0 7px 7px;
        }

        &:hover  {
            background: rgba(140, 137, 137, 0.13);
        }
`;
